import Env from '@/constants/Env';

/**
 * 获取环境变量值
 * @param envName 环境变量名 （约定`${envName}_DEV`为对应开发联调环境，`${envName}_QA`为对应测试环境，`${envName}_PRE`为对应预发布环境，开发和生产均为process.env[envName]）
 */
export const getEnvValue = (envName: string): string | undefined => {
  switch (process.env.REACT_APP_ENV) {
    case Env.Dev:
      return process.env[`${envName}_DEV`] || process.env[envName];
    case Env.Qa:
      return process.env[`${envName}_QA`] || process.env[envName];
    case Env.Pre:
      return process.env[`${envName}_PRE`] || process.env[envName];
    default:
      return process.env[envName];
  }
};
